import { API, authClient } from "../index";

// Get all updates
export const getUpdates = () => {
	return authClient().get(`${API}/update`);
};
